import React, { useRef } from 'react'
import ReactDOM from 'react-dom'
import { flowRight } from 'lodash'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { useClickAway } from 'react-use'

import TimeKeeper from 'react-timekeeper'

import './extended-time-keeper.pcss'

export const ExtendedTimeKeeperContainer = () => {
    // this is where we React.portal the time keeper component
    return <div id="extended-time-keeper-container" />
}

const ExtendedTimeKeeper = ({
    time,
    onChange,
    onDoneClick,
    onCloseRequest,
    doneButton,
}) => {
    const innerRef = useRef(null)

    useClickAway(innerRef, () => {
        onCloseRequest && onCloseRequest()
    })

    return (
        ReactDOM.createPortal(
            (
                <div
                    role="none"
                    onClick={(e) => e.preventDefault()}
                    className="extended-time-keeper"
                >
                    <div ref={innerRef} className="extended-time-keeper__inner">
                        <TimeKeeper
                            time={time}
                            onChange={onChange}
                            switchToMinuteOnHourSelect={true}
                            coarseMinutes={5}
                            forceCoarseMinutes
                            onDoneClick={onDoneClick}
                            hour24Mode
                            doneButton={doneButton || undefined}
                        />
                    </div>
                </div>
            ),
            document.getElementById('extended-time-keeper-container') // #extended-time-keeper-container div needs to exist close to body
                                                             // (outside any special css positioning)

        )
    )
}

export default flowRight(
    withErrorBoundaryNoRender,
)(ExtendedTimeKeeper)
